export const FETCH_AUDIENCES_REQUEST = 'onboarder/FETCH_AUDIENCES_REQUEST';
export const FETCH_AUDIENCES_SUCCESS = 'onboarder/FETCH_AUDIENCES_SUCCESS';
export const FETCH_AUDIENCES_FAILURE = 'onboarder/FETCH_AUDIENCES_FAILURE';

export const FETCH_AUTOMATED_BROADCAST_REQUEST = 'onboarder/FETCH_AUTOMATED_BROADCAST_REQUEST';
export const FETCH_AUTOMATED_BROADCAST_SUCCESS = 'onboarder/FETCH_AUTOMATED_BROADCAST_SUCCESS';
export const FETCH_AUTOMATED_BROADCAST_FAILURE = 'onboarder/FETCH_AUTOMATED_BROADCAST_FAILURE';

export const SEARCH_AUTOMATED_BROADCAST_REQUEST = 'onboarder/SEARCH_AUTOMATED_BROADCAST_REQUEST';
export const SEARCH_AUTOMATED_BROADCAST_SUCCESS = 'onboarder/SEARCH_AUTOMATED_BROADCAST_SUCCESS';

export const SHOW_ERROR = 'onboarder/SHOW_ERROR';
export const TOGGLE_ERROR_MODAL = 'onboarder/TOGGLE_ERROR_MODAL';

export const HANDLE_DROP_REQUEST = 'onboarder/HANDLE_DROP_REQUEST';
export const HANDLE_DROP_SUCCESS = 'onboarder/HANDLE_DROP_SUCCESS';
export const HANDLE_DROP_FAILURE = 'onboarder/HANDLE_DROP_FAILURE';

export const HANDLE_REMOVE_REQUEST = 'onboarder/HANDLE_REMOVE_REQUEST';
export const HANDLE_REMOVE_SUCCESS = 'onboarder/HANDLE_REMOVE_SUCCESS';
export const HANDLE_REMOVE_FAILURE = 'onboarder/HANDLE_REMOVE_FAILURE';

export const UPDATE_AUTOMATED_REQUEST = 'onboarder/UPDATE_AUTOMATED_REQUEST';
export const UPDATE_AUTOMATED_SUCCESS = 'onboarder/UPDATE_AUTOMATED_SUCCESS';
export const UPDATE_AUTOMATED_FAILURE = 'onboarder/UPDATE_AUTOMATED_FAILURE';

export const HANDLE_SELECT_ABNODE = 'onboarder/HANDLE_SELECT_ABNODE';

export const PUSH_INTO_UNDO_STACK = 'onboarder/PUSH_INTO_UNDO_STACK';

export const UNDO_REQUEST = 'onboarder/UNDO_REQUEST';
export const UNDO_SUCCESS = 'onboarder/UNDO_SUCCESS';
export const UNDO_FAILURE = 'onboarder/UNDO_FAILURE';

export const REDO_REQUEST = 'onboarder/REDO_REQUEST';
export const REDO_SUCCESS = 'onboarder/REDO_SUCCESS';
export const REDO_FAILURE = 'onboarder/REDO_FAILURE';

export const CHANGE_PROPERTIES = 'onboarder/CHANGE_PROPERTIES';



// WEBPACK FOOTER //
// ./src/containers/onboarder/constants.js